import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import BacktestService from "../../../service/backtest.service";
import CompareContent from "./compareContent";
import { modifyDataDrill, drillDownModify } from "./commonFunctions";
import "./compare.css";

class Compare extends Component {
  state = {
    columns: [{ title: "Symbol" }, { title: "Weight" }],
    data: [
      ["12", "Alpha"],
      ["22", "Beta"]
    ],
    getBacktest: [],
    filteredObjects: [],
    items: [],
    iqcioPieValue: [],
    iqcioPieTitle: [],
    Spinner: true,
    yourTitle: [],
    yourValue: [],
    optimizedTable: [],
    SpinnerPie1: true,
    yourTable: [],
    yourChartOptions: [],
    yourDrilldown: [],
    iqcioChartOptions: [],
    iqcioDrilldown: [],
    ErrorLoadingData: false
  };
  async componentDidMount() {
    const { dataFromChild } = this.props;

    // redux
    const {
      setTableHead,
      setYourTableData,
      setIqTableData,
      setYourDrillData,
      setIQDrillData,
      setYrChartOption,
      setIQChartOption
    } = this.props;
    setTableHead(this.state.columns);

    if (this.props.items.length) {
      let data = this.props.items;
      var yourTitle = [],
        yourValue = [];
      data.forEach(d => {
        yourTitle.push(d[0]);
        yourValue.push(d[1]);
      });
      this.setState({
        items: data,
        yourTitle,
        yourValue
      });
    }
    if (dataFromChild !== 0)
      try {
        await BacktestService.getBacktest(
          `${dataFromChild}`,
          "DUMMY",
          "BACKTEST"
        ).then(res => {
          if (res) {
            if (res.getBenchmarkData) {
              let data = res.getBenchmarkData;

              var mostRecentDate = moment(
                Math.max.apply(
                  null,
                  data.map(e => {
                    return moment(e.dt);
                  })
                )
              ).format("YYYY-MM-DD");

              let formatedDate = moment(mostRecentDate).format("YYYY-MM-DD");

              var filteredObjects = data.filter(function(e) {
                return e.dt === `${formatedDate}`;
              });
              var title = [],
                value = [],
                optimizedTable = [];
              filteredObjects.forEach(d => {
                title.push(d["fund_name"]);
                value.push(d["allocation"] * 1);
                optimizedTable.push([
                  `${d.fund_asset_class_focus} - ${d.fund_name}`,
                  +d.allocation
                ]);
              });

              var chartData2 = modifyDataDrill(filteredObjects);

              setIQDrillData(chartData2);
              var chartOptions2 = drillDownModify(filteredObjects);
            }
            if (res.getPortfolioData) {
              let data = res.getPortfolioData;

              var recentDate = moment(
                Math.max.apply(
                  null,
                  data.map(e => {
                    return moment(e.dt);
                  })
                )
              ).format("YYYY-MM-DD");

              let formatedDate = moment(recentDate).format("YYYY-MM-DD");

              var filteredObj = data.filter(function(e) {
                return e.dt === `${formatedDate}`;
              });
              var t = [],
                v = [],
                yourTable = [];
              filteredObj.forEach(d => {
                t.push(d["fund_name"]);
                v.push(d["allocation"] * 1);
                yourTable.push([
                  `${d.fund_asset_class_focus} - ${d.fund_name}`,
                  +d.allocation
                ]);
              });

              setYourTableData(yourTable);

              var chartData = modifyDataDrill(filteredObj);
              setYourDrillData(chartData);
              setIqTableData(optimizedTable);

              var chartOptions = drillDownModify(filteredObj);
              setYrChartOption(chartOptions);
              setIQChartOption(chartOptions2);
            }

            this.setState({
              getBacktest: res,
              filteredObjects,
              iqcioPieTitle: title,
              iqcioPieValue: value,
              optimizedTable,
              Spinner: false,
              yourTable,
              yourDrilldown: chartData,
              yourChartOptions: chartOptions,
              SpinnerPie1: false,
              iqcioChartOptions: chartOptions2,
              iqcioDrilldown: chartData2
            });
          }
        });
      } catch (err) {
        this.setState({
          ErrorLoadingData: true
        });
      }
  }
  navToDashboard = () => {
    browserHistory.push({
      pathname: "/dashboard",
      state: {
        foo: parseInt(this.props.dataFromChild),
        benchmark: "DUMMY",
        type: "BACKTEST",
        typeName: "IQCIO Model",
        headingName: "Your Portfolio versus IQCIO optimized"
      }
    });
  };
  backStepNav = () => {
    this.props.navToBackStep();
  };
  render() {
    const {
      yourDrilldown,
      yourChartOptions,
      iqcioDrilldown,
      iqcioChartOptions,
      yourTable,
      columns,
      optimizedTable,
      ErrorLoadingData
    } = this.state;
    return (
      <div>
        <p>
          Presented below is the birds eye view of your portfolio and the
          recommended IQCIO model. Click on the <b>Dashboard</b> button below to
          view a more detailed analysis of the recommended IQCIO model
        </p>
        <CompareContent
          yourDrilldown={yourDrilldown}
          yourChartOptions={yourChartOptions}
          iqcioDrilldown={iqcioDrilldown}
          iqcioChartOptions={iqcioChartOptions}
          yourTable={yourTable}
          columns={columns}
          optimizedTable={optimizedTable}
          id={"drill1"}
          idIn={"drill_content1"}
          id2={"drill2"}
          idIn2={"drill_content2"}
          ErrorLoadingData={ErrorLoadingData}
        />

        <div className="addbtn-group">
          <button className="btn btn-db" onClick={this.backStepNav}>
            <i className="fa fa-angle-left" /> Back
          </button>
          <button
            className="btn btn-db"
            onClick={this.navToDashboard}
            disabled={
              this.props.dataFromChild === 0 || ErrorLoadingData === true
                ? true
                : false
            }
          >
            Dashboard <i className="fa fa-angle-right" />
          </button>
        </div>
      </div>
    );
  }
}

export default connect(null, dispatch => ({
  setTableHead: payload =>
    dispatch({ type: "COMPARE_PORTFOLIO_TABLE_HEAD", payload }),
  setYourTableData: payload =>
    dispatch({ type: "SET_YOURTABLE_DATA", payload }),
  setIqTableData: payload => dispatch({ type: "SET_IQTABLE_DATA", payload }),
  setYourDrillData: payload => dispatch({ type: "SET_YOURDRILLDOWN", payload }),
  setIQDrillData: payload => dispatch({ type: "SET_IQDRILLDOWN", payload }),
  setYrChartOption: payload =>
    dispatch({ type: "SET_YR_CHARTOPTION", payload }),
  setIQChartOption: payload => dispatch({ type: "SET_IQ_CHARTOPTION", payload })
}))(Compare);



// WEBPACK FOOTER //
// ./src/components/pages/compare/Compare.jsx